import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import ParameterTable from "src/components/table/parameter-table"
import DatalakeService from "src/services/datalake-service"
import { DATE_FORMAT_SHOW } from "src/utils/constants"
import dayjs from "dayjs"

const ParameterDatalakeContraparteTable = ({ filters, endpoint, loading, disableToolbar }) => {
    const calcService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })


    useEffect(() => {
        if (filters && filters.length > 0) {
            onFilter(filters, 25, 0)
        } else {
            loadData()
        }
    }, [])

    const loadData = () => {
        loading(true)
        calcService.loadEndpoint(endpoint).then((response) => {
            loading(false)
            const { body } = response
            const { results } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))

            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "CPFCNPJ": null,
            "RaizCNPJ": null,
            "RazaoSocial": null,
            "NomeFantasia": null,
            "Setor": null,
            "SubSetor": null,
            "Site_RI": null,
            "GrupoEconomico_Nome": null,
            "GrupoEconomico_RaizCNPJ": null,
            "Observacao": null,
            "GrupoRating": null,
            "GrupoAuditoria": null,
            "GrupoCustodiante": null,
            "GrupoCoordenadorLider": null,
            "GrupoFiduciario": null,
            "GrupoIFRecebedora": null,
            "GrupoSecuritizador": null,
            "Atividade": null,
            "MesFechamento": null,
            "TipoCadastro": null,
            "PeriodicidadeBalanco": null,
            "EGEM": null,
            "EFRF": null
        }

        loading(true)
        return calcService.createTableEndpoint(endpoint, body).then(() => {
            loading(false)
            loadData()
        }).catch((err) => {
            loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')
        loading(true)
        calcService.loadPaginationEndpoint(endpoint, query, limit, offset).then((response) => {
            loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }


    const updateRow = async (newRow) => {
        const { ID, CPFCNPJ, RaizCNPJ, RazaoSocial, NomeFantasia, Setor, SubSetor, Site_RI, GrupoEconomico_Nome,
            GrupoEconomico_RaizCNPJ, Observacao, GrupoRating, GrupoAuditoria, GrupoCustodiante,
            GrupoCoordenadorLider, GrupoFiduciario, GrupoIFRecebedora, GrupoSecuritizador, Atividade, MesFechamento, TipoCadastro, PeriodicidadeBalanco, EGEM, EFRF
        } = newRow

        const body = {
            "CPFCNPJ": CPFCNPJ,
            "RaizCNPJ": RaizCNPJ,
            "RazaoSocial": RazaoSocial,
            "NomeFantasia": NomeFantasia,
            "Setor": Setor,
            "SubSetor": SubSetor,
            "Site_RI": Site_RI,
            "GrupoEconomico_Nome": GrupoEconomico_Nome,
            "GrupoEconomico_RaizCNPJ": GrupoEconomico_RaizCNPJ,
            "Observacao": Observacao,
            "GrupoRating": GrupoRating,
            "GrupoAuditoria": GrupoAuditoria,
            "GrupoCustodiante": GrupoCustodiante,
            "GrupoCoordenadorLider": GrupoCoordenadorLider,
            "GrupoFiduciario": GrupoFiduciario,
            "GrupoIFRecebedora": GrupoIFRecebedora,
            "GrupoSecuritizador": GrupoSecuritizador,
            "Atividade": Atividade,
            "MesFechamento": MesFechamento,
            "TipoCadastro": TipoCadastro,
            "PeriodicidadeBalanco": PeriodicidadeBalanco,
            "EGEM": EGEM,
            "EFRF": EFRF
        }

        loading(true)
        return calcService.updateTableEndpoint(endpoint, ID, body).then(() => {
            loading(false)
        }).catch((err) => {
            loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        const { ID } = row
        return calcService.deleteTableEndpoint(endpoint, ID).then(() => {
            loading(false)
            loadData()
        }).catch((err) => {
            loading(false)
            throw err
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            flex: true,
        },
        {
            field: 'CPFCNPJ',
            headerName: 'CPFCNPJ',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'RaizCNPJ',
            headerName: 'RaizCNPJ',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'RazaoSocial',
            headerName: 'RazaoSocial',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'NomeFantasia',
            headerName: 'NomeFantasia',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'GrupoEconomico_Nome',
            headerName: 'GrupoEconomico_Nome',
            flex: 1,
            minWidth: 200,
            maxWidth: 400,
            editable: true
        },
        {
            field: 'GrupoEconomico_RaizCNPJ',
            headerName: 'GrupoEconomico_RaizCNPJ',
            flex: 1,
            minWidth: 200,
            maxWidth: 400,
            editable: true
        },
        {
            field: 'MesFechamento',
            headerName: 'MesFechamento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Observacao',
            headerName: 'Observacao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Atividade',
            headerName: 'Atividade',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'Site_RI',
            headerName: 'Site_RI',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        }, 
        {
            field: 'Setor',
            headerName: 'Setor',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'SubSetor',
            headerName: 'SubSetor',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'TipoCadastro',
            headerName: 'Tipo Cadastro',
            flex: 1,
            minWidth: 150,
            maxWidth: 300,
            editable: true
        },
        {
            field: 'PeriodicidadeBalanco',
            headerName: 'Periodicidade de Balanço',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            editable: true
        },
        {
            field: 'EGEM',
            headerName: 'EGEM',
            flex: 1,
            typeComponent: 'boolean',
            minWidth: 150,
            maxWidth: 350,
            editable: true,
        },
        {
            field: 'EFRF',
            headerName: 'EFRF',
            flex: 1,
            typeComponent: 'boolean',
            minWidth: 150,
            maxWidth: 350,
            editable: true,
        },
        {
            field: 'GrupoAuditoria',
            headerName: 'GrupoAuditoria',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'GrupoRating',
            headerName: 'GrupoRating',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'GrupoCustodiante',
            headerName: 'GrupoCustodiante',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'GrupoCoordenadorLider',
            headerName: 'GrupoCoordenadorLider',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'GrupoFiduciario',
            headerName: 'GrupoFiduciario',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'GrupoIFRecebedora',
            headerName: 'GrupoIFRecebedora',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'GrupoSecuritizador',
            headerName: 'GrupoSecuritizador',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => dayjs(params.value).format(DATE_FORMAT_SHOW),
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => dayjs(params.value).format(DATE_FORMAT_SHOW),
        }
    ]

    return (
        <div>
            <ParameterTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                loadData={loadData}
                pagination={pagination}
                customFilter={true}
                disableToolbar={disableToolbar ? disableToolbar : false} />
        </div>
    )
}

ParameterDatalakeContraparteTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    filters: PropTypes.array,
    disableToolbar: PropTypes.bool,
}

export default ParameterDatalakeContraparteTable
